// extracted by mini-css-extract-plugin
var _1 = "BreakLine_breakLine__7TMxn";
export { _1 as "breakLine" }
